module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1529-e01c260f5ee98f13804949a5835082ef.png";